// extracted by mini-css-extract-plugin
module.exports = {"installation":"Installation_installation__any3a","delete":"Installation_delete__0alTz"};